<template >
  <div id="notification-event">
    <div class="mt-3 notify-container">
      <div class="mr-20 mb-3">
        <vs-row vs-w="12" vs-type="flex" vs-justify="space-between">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <vs-input v-model="dataSearchNoti.mmsi" class="w-full" placeholder="MMIS" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <vs-input v-model="dataSearchNoti.imo" class="w-full" placeholder="IMO" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <vs-input v-model="dataSearchNoti.callSing" class="w-full" placeholder="Call Sing" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <vs-input v-model="dataSearchNoti.name" class="w-full" placeholder="Name" />
          </vs-col>
        </vs-row>
      </div>
      <div class="mr-20 mb-3">
        <vs-row vs-w="12" vs-type="flex" vs-justify="space-between">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <v-select
              id="shiptype"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              :options="shipTypes"
              v-model="selectedShipType"
              class="w-full"
              label="name"
              label-placeholder="Ship type"
              placeholder="Ship type"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <flat-pickr
              :config="configdateTimePicker"
              v-model="formdatetime"
              placeholder="From"
              class="w-full inputDateNoti"
            />
            <button class="ml-0 p-3 xclose" @click="formdatetime=''">x</button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <flat-pickr
              :config="configdateTimePicker"
              v-model="todatetime"
              placeholder="To"
              class="w-full inputDateNoti"
            />
            <button class="ml-0 p-3 xclose" @click="todatetime=''">x</button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <vs-button
              class="ml-1 w-full"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              @click="searchNoti()"
            >Search</vs-button>
          </vs-col>
        </vs-row>
      </div>

      <vs-table
        :sst="true"
        :data="dataEventNotification"
        v-model="selected"
        pagination
        max-items="10"
      >
        <template slot="thead">
          <vs-th sort-key="to_s">No.</vs-th>
          <vs-th sort-key="to_s">mmsi name event zone</vs-th>
          <vs-th sort-key="longitude">longitude</vs-th>
          <vs-th sort-key="latitude">latitude</vs-th>
          <vs-th sort-key="id">Date</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody ref="tbody">
            <vs-tr v-for="(item, index) in data" :data="item" :key="index">
              <vs-td :data="item.index">{{ index+1 }}</vs-td>
              <vs-td :data="item.to_s">{{ item.to_s }}</vs-td>
              <vs-td :data="item.longitude">{{ item.longitude }}</vs-td>
              <vs-td :data="item.latitude">{{ item.latitude }}</vs-td>
              <vs-td
                :data="item.created_at_formatted"
              >{{ getDateFormatted(item.created_at_formatted) }}</vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  name: "NotificationEvent",
  components: {
    flatPickr,
    vSelect
  },
  data() {
    return {
      dataSearchNoti: {
        mmsi: "",
        imo: "",
        callSing: "",
        name: ""
      },
      formdatetime: "",
      todatetime: "",
      selectedShipType: {
        id: 81,
        to_s: "80 Tanker, all ships of this type",
        code: "80",
        name: "Tanker, all ships of this type",
        url: "http://rts.excise-online.com/admin/ship_types/81.json"
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d/m/Y"
      },
      selected: {},
      mmis: "",
      imo: "",
      callSing: "",
      name: "",
      selectValue: "",
      fromdatetime: "",
      accessEmail: "",
      accessToken: "",
      data: []
    };
  },
  computed: {
    ...mapState({
      dataEventNotification: state => state.notification.dataEvent,
      shipTypes: state => state.notification.shipTypes,
      loading: state => state.notification.loading
    })
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    selected(val) {
      localStorage.setItem("detailNoti", JSON.stringify(val.id));
      let routeData = this.$router.resolve({ name: "DetailNotification" });
      window.open(routeData.href, "_blank");
    }
  },
  mounted() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "event notification");
    this.$store.dispatch("updateTitlePage", "event notification");
    // get notify Event List
    this.getListNotification();
    // get ship type
    this.getShipType();
  },
  methods: {
    getListNotification() {
      let params = { limit: 20 };
      if (this.selectedShipType.id) {
        params = {
          ...params,
          "q[vessel_event_vessel_ship_type_id_eq]": this.selectedShipType.id
        };
      }
      const headers = {
        "X-User-Email": this.accessEmail,
        "X-User-Token": this.accessToken
      };
      const payload = {
        params,
        headers
      };
      this.$store.dispatch("getNotificationEvent", payload);
    },
    getShipType() {
      const headers = {
        "X-User-Email": this.accessEmail,
        "X-User-Token": this.accessToken
      };
      const payload = { headers };
      this.$store.dispatch("getShipTypesNotify", payload);
    },
    getDateFormatted(str) {
      const index = str.indexOf(" ");
      let t = str.substring(index, str.length).trim();
      t = `${t.substring(0, 2)}:${t.substring(2, t.length)}`;
      let d = str.substring(0, index);
      return `${d} ${t}`;
    },
    searchNoti() {
      if (this.selectedShipType == null) {
        this.selectedShipType = {
          id: ""
        };
      }
      let params = {};
      let headers = {
        "X-User-Email": this.accessEmail,
        "X-User-Token": this.accessToken
      };
      if (this.formdatetime != "" || this.todatetime != "") {
        params = {
          utf8: "✓",
          "q[vessel_event_vessel_mmsi_cont]": this.dataSearchNoti.mmsi,
          "q[vessel_event_vessel_imo_number_cont]": this.dataSearchNoti.imo,
          "q[vessel_event_vessel_call_sign_cont]": this.dataSearchNoti.callSing,
          "q[vessel_event_vessel_name_cont]": this.dataSearchNoti.name,
          "q[vessel_event_vessel_ship_type_id_eq]": this.selectedShipType.id,
          "q[created_at_gteq]": this.formdatetime,
          "q[created_at_lteq]": this.todatetime
        };
      } else {
        params = {
          utf8: "✓",
          "q[vessel_event_vessel_mmsi_cont]": this.dataSearchNoti.mmsi,
          "q[vessel_event_vessel_imo_number_cont]": this.dataSearchNoti.imo,
          "q[vessel_event_vessel_call_sign_cont]": this.dataSearchNoti.callSing,
          "q[vessel_event_vessel_name_cont]": this.dataSearchNoti.name,
          "q[vessel_event_vessel_ship_type_id_eq]": this.selectedShipType.id,
          "q[created_at_gteq]": this.formdatetime,
          "q[created_at_lteq]": this.todatetime,
          limit: 10
        };
      }
      this.$store.dispatch("getNotificationEventWithParams", {
        params,
        headers
      });
    }
  }
};
</script>
<style>
.selectbox {
  max-width: 30em;
  margin: 1em auto;
}
.notify-container {
  margin-top: 8px;
  padding: 16px;
  background-color: white;
}
.inputDateNoti {
  height: 36px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 10px;
}
.xclose {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
        
    

